import {loader} from './logo';
const apiUrl = process.env.REACT_APP_apiUrl;
const crossOrigin = process.env.REACT_APP_crossOrigin;
const webSocket = process.env.REACT_APP_webSocket;
const imagesPath = process.env.REACT_APP_imagesPath;
let currentDateEST = new Date(new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
}));
let startOfficeEST = new Date(currentDateEST.getFullYear()+'/'+(currentDateEST.getMonth()+1)+'/'+currentDateEST.getDate()+' 09:00 AM');
let endOfficeEST = new Date(currentDateEST.getFullYear()+'/'+(currentDateEST.getMonth()+1)+'/'+currentDateEST.getDate()+' 05:00 PM');

let currentDate = new Date(currentDateEST);
let startOffice = new Date(startOfficeEST);
let endOffice = new Date(endOfficeEST);
let text = '';
if(currentDate.getTime()>=startOffice.getTime() && currentDate.getTime()<=endOffice.getTime()){
    text = '<b>MedConnect</b> enables you to speak with an MSL right now or schedule a meeting for another time.';
}else{
    text = '<b>MedConnect</b> enables you to schedule a meeting to speak with an MSL. ';
}

const WelcomeTexts= [text, 'MSLs are available to meet Monday-Friday from 9<span>AM</span> to 5<span>PM</span> EST.', 'This tool is intended for healthcare professionals only. Click "CONTINUE" below if you are a healthcare professional.', 'MSL = Medical Science Liaison.'];
const CONTINUE = process.env.REACT_APP_CONTINUE;
const END_CHAT = process.env.REACT_APP_END_CHAT;
const selectDateMsg = 'Select a Date and Time Above';
const noSlotsMsg = 'Sorry, no slots are available for the selected date. Please select another date.';
const BackToCalendar = 'Back to Calendar';
const IntervalMessages = ['Ok. Great! <br /><br /> I\'m connecting you to the next available MSL.' ,'Thank you for holding while we connect you.',  'We\'re working to locate an MSL.'];
const  idleMessage ="Sorry, the connection has broken. Please end chat and start again";
const logo = process.env.REACT_APP_logo;
const logoWhite = process.env.REACT_APP_logoWhite;
//const loader = process.env.REACT_APP_loader;

export { apiUrl, crossOrigin, webSocket, WelcomeTexts, CONTINUE, END_CHAT, selectDateMsg, noSlotsMsg, BackToCalendar, IntervalMessages, idleMessage, imagesPath, logo, logoWhite, loader };